export default __webpack_public_path__ + "static/media/367.752d1ecd.png";